import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CommandQueue from "./pages/CommandQueue";
import IssueDetail from "./pages/IssueDetail";
import NewIssue from "./pages/NewIssue";
import Analytics from "./pages/Analytics";
import Users from "./pages/Users";
import "@/App.css";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-primary font-heading text-xl uppercase tracking-wider animate-pulse">
          Loading ORBIT...
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/issues" 
              element={
                <ProtectedRoute>
                  <CommandQueue />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/issues/:id" 
              element={
                <ProtectedRoute>
                  <IssueDetail />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/new-issue" 
              element={
                <ProtectedRoute>
                  <NewIssue />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analytics" 
              element={
                <ProtectedRoute allowedRoles={["GM", "DM"]}>
                  <Analytics />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users" 
              element={
                <ProtectedRoute allowedRoles={["GM"]}>
                  <Users />
                </ProtectedRoute>
              } 
            />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
